import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";
import "./hpa.css";

/**
 * Block 11.1 · § 8 · Intro Experience (3 Screens)
 *
 * Screen 1 · Was steckt wirklich in dir?
 * Screen 2 · POTENTIAL → EXPRESSION
 * Screen 3 · Es gibt keine richtigen Antworten. → BEGINNEN
 *
 * Kein Progress-Balken hier – Intro ist keine Assessment-Zählung.
 */
export default function HpaIntro() {
  const [step, setStep] = useState(0); // 0..2
  const navigate = useNavigate();

  const next = () => {
    if (step < 2) setStep((s) => s + 1);
    else navigate("/hpa/consent");
  };

  return (
    <div className="hpa hpa-canvas" data-testid="hpa-intro">
      <SEO title="HPA · Intro" description="HPA Intro" path="/hpa/intro" />
      <div className="container-sat max-w-3xl pt-28 pb-24 hpa-thread">
        <div className="pl-6 md:pl-10">
          <div
            className="hpa-overline mb-14"
            data-testid="hpa-intro-overline"
          >
            HPA · {step + 1} von 3
          </div>

          {step === 0 && <IntroOne />}
          {step === 1 && <IntroTwo />}
          {step === 2 && <IntroThree />}

          <div className="mt-20 flex items-center justify-between">
            {step > 0 ? (
              <button
                type="button"
                className="hpa-btn-ghost"
                onClick={() => setStep((s) => s - 1)}
                data-testid="hpa-intro-back"
              >
                ← Zurück
              </button>
            ) : (
              <Link
                to="/hpa"
                className="hpa-btn-ghost"
                data-testid="hpa-intro-exit"
              >
                ← Abbrechen
              </Link>
            )}

            <button
              type="button"
              className="hpa-btn-primary"
              onClick={next}
              data-testid={
                step === 2 ? "hpa-intro-cta-beginnen" : "hpa-intro-cta-weiter"
              }
            >
              {step === 2 ? "Beginnen" : "Weiter"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function IntroOne() {
  return (
    <div data-testid="hpa-intro-screen-1">
      <h1 className="hpa-headline text-4xl md:text-5xl mb-10">
        Was steckt wirklich <em>in dir</em>?
      </h1>
      <p className="hpa-lede text-lg md:text-xl leading-relaxed max-w-xl">
        Nicht alles, was in dir angelegt ist, wird in jeder Lebensphase und in
        jeder Situation gleichermaßen sichtbar.
      </p>
    </div>
  );
}

function IntroTwo() {
  return (
    <div data-testid="hpa-intro-screen-2">
      <div className="flex flex-col items-start gap-4 mb-12">
        <div
          className="hpa-overline"
          style={{ color: "var(--hpa-gold)" }}
        >
          Potential
        </div>
        <div className="h-16 w-px bg-[color:var(--hpa-line)]" />
        <div
          className="hpa-overline"
          style={{ color: "var(--hpa-text-soft)" }}
        >
          Expression
        </div>
      </div>
      <p className="hpa-lede text-lg md:text-xl leading-relaxed max-w-xl">
        HPA unterscheidet zwischen dem, was dir grundsätzlich zur Verfügung
        steht, und dem, was davon aktuell sichtbar wird.
      </p>
    </div>
  );
}

function IntroThree() {
  return (
    <div data-testid="hpa-intro-screen-3">
      <h2 className="hpa-headline text-3xl md:text-4xl mb-10">
        Es gibt keine <em>richtigen</em> Antworten.
      </h2>
      <p className="hpa-lede text-lg md:text-xl leading-relaxed max-w-xl">
        Antworte so, wie du dich tatsächlich erlebst – nicht so, wie du glaubst,
        sein zu müssen.
      </p>
    </div>
  );
}
